import createTaskModule from '../utils/createTaskModule';

export const { actions: taskModuleActions, store: taskModuleStore } = createTaskModule();
export const isDetailsDialogOpen = () => taskModuleStore().isOpen;
